import clsx from "clsx"
import { FaChevronDown } from "react-icons/fa"
import React from "react"

export const AccordionItem = ({
  title,
  children,
  open,
  onToggle,
  headerClassName,
  panelClassName,
  nested = false,
}: {
  title: React.ReactNode
  children: React.ReactNode
  open: boolean
  onToggle: () => void
  headerClassName?: string
  panelClassName?: string
  /** Second-level row inside Program (indented header + panel). */
  nested?: boolean
}) => {
  const panelId = React.useId()

  return (
    <div>
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={panelId}
        className={clsx(
          "font-bold text-sm w-full text-left",
          "flex justify-between items-center font-urbanist",
          nested ? "py-3 pl-8 pr-5" : "py-4 px-5",
          open ? "text-new-blue" : "text-black",
          headerClassName
        )}
      >
        <span>{title}</span>
        <FaChevronDown
          className={clsx(
            "shrink-0 rotate-animation",
            open ? "rotate-animation__up text-new-blue" : "text-black"
          )}
        />
      </button>
      <div
        id={panelId}
        className={clsx("gap-2 px-5", open ? "grid" : "hidden", panelClassName)}
      >
        {children}
      </div>
    </div>
  )
}

interface MobileLinkProps {
  link: string
  children: React.ReactNode
}

export const MobileLink = ({
  children,
  link,
  className,
}: MobileLinkProps & { className?: string }) => {
  return (
    <a
      href={link}
      className={clsx(
        "block px-3 py-2 text-sm font-inter font-normal text-black rounded-lg",
        "active:text-new-blue active:bg-[rgba(0,76,231,0.20)]",
        "hover:text-new-blue hover:bg-[rgba(0,76,231,0.20)]",
        className
      )}
    >
      {children}
    </a>
  )
}

export * from "./AccountAccordion"
export * from "./ProgramAccordion"
export * from "./StaticAccordion"
